import React from 'react';
import { Icons } from '../../components/Icon.jsx';

const Breadcrumb = ({ crumbs, onNavigate }) => {
  return (
    <div className="flex items-center gap-1 text-xs">
      {crumbs.map((crumb, idx) => (
        <React.Fragment key={crumb.id}>
          {idx > 0 && (
            <span className="text-gray-400 mx-1">
              <Icons.ChevronRight className="w-2.5 h-2.5" />
            </span>
          )}
          <button
            onClick={() => onNavigate(crumb.index)}
            className={`flex items-center gap-1 px-2 py-1 rounded transition-colors ${
              idx === crumbs.length - 1
                ? 'bg-blue-100 text-blue-800 font-bold cursor-default shadow-sm'
                : 'text-gray-500 hover:bg-gray-100 hover:text-gray-800'
            }`}
            disabled={idx === crumbs.length - 1}
          >
            {idx === 0 && <Icons.Move className="w-3 h-3" />}
            {crumb.label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
